import Dropdown from "../../../atoms/Dropdown";
import useDischargeSummary, { DischargeSummaryProps } from "../hooks/useDischargeSummary";
import "./DischargeSummary.scss";

const DischargeSummary = (props: DischargeSummaryProps) => {
  const {
    formData,
    formObject,
    therapyOptions,
    indicationOptions,
    handleChange,
    showTherapyError,
    showIndicationError,
  } = useDischargeSummary(props);

 
  return (
    <section className="discharge-summary">
      {/* Title */}
      {/* <div className="grid grid-cols-2 gap-4 items-end w-full">
        <div>
          <h2 className="discharge-summary__title">Latest Discharge Summary</h2>
          <div className="discharge-summary__upload-box">
            <label
              className="discharge-summary__upload-btn"
              style={{ cursor: "pointer" }}
            >
              {formObject.dischargeSummary || "Upload Discharge Summary"}
              <input
                type="file"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files && e.target.files[0];
                  if (file) {
                    updateFormObject("dischargeSummary", file.name);
                  }
                }}
              />
            </label>
          </div>
        </div>

        <div>
          <label className="input-label mb-2" htmlFor={"add-notes"}>
            Add Notes
          </label>
          <textarea
            className="textarea-box"
            name={"add-notes"}
            rows={4}
            value={formObject.notes}
            onChange={(e) => updateFormObject("notes", e.target.value)}
            placeholder={"Add Notes"}
            id={"add-notes"}
          />
        </div>
      </div> */}
      {/* Controls */}
      <div className="grid grid-cols-4 items-end gap-4 w-full">
        {formData.cancerType &&
          therapyOptions.length > 0 &&
          formData.primaryDrug && (
            <Dropdown
              options={therapyOptions}
              name="therapy"
              onChange={handleChange}
              value={formObject.therapy}
              label="Select Approval/Therapy"
              error={showTherapyError}
              helperText={showTherapyError ? "Therapy is required" : undefined}
              //helperText="Required"
            />
          )}
        {/* Level 4 Dropdown Indication */}
        {formObject.therapy && indicationOptions.length > 0 && (
          <Dropdown
            options={indicationOptions}
            name="therapy_indication"
            onChange={handleChange}
            value={formObject.indication}
            label="Select Indication"
            error={showIndicationError}
            helperText={showIndicationError ? "Indication is required" : undefined}
          />
        )}
      </div>
    </section>
  );
};

export default DischargeSummary;